export type RouteName = 'login' | 'register' | 'forgot' | 'dashboard' | 'servers' | 'server' | 'logs' | 'metrics' | 'commands' | 'settings';
export interface Route { name: RouteName; serverId?: string; }
export const parseRoute = (): Route => {
  const hash = location.hash.replace(/^#\/?/, '');
  const [name = 'dashboard', value] = hash.split('/');
  const allowed: RouteName[] = ['login','register','forgot','dashboard','servers','server','logs','metrics','commands','settings'];
  return { name: allowed.includes(name as RouteName) ? name as RouteName : 'dashboard', serverId: value ? decodeURIComponent(value) : undefined };
};
export const navigate = (name: RouteName, serverId?: string): void => { location.hash = `#/${name}${serverId ? `/${encodeURIComponent(serverId)}` : ''}`; };
